import React, { Fragment } from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { H5, Btn } from "../../AbstractElements";
import { Row, Col, CardBody, CardFooter, CardHeader, Form, FormGroup, Label, Input, Container, Card } from 'reactstrap';
import { Update, Cancel } from '../../Constant';
import SvgIcon from '../../Components/Common/Component/SvgIcon';
import { questionOperations } from '../../state/ducks/question';
import { masterOperations } from '../../state/ducks/master';
import { categoryOperations } from '../../state/ducks/category';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import * as API_URL from "../../env.js";
import request from "../../utils/request";
import Select from "react-select";
class QuestionEdit extends React.Component {

  constructor() {
    super();
    this.state = {
      category: [],
      language: [],
      selectedQuestionData: {},
      selectedCategories: [],
      isViewMode: localStorage.getItem("isViewMode") === "true", // Check localStorage for view mode
    }
  }

  async componentDidMount() {
    try {
      const isViewMode = localStorage.getItem("isViewMode") === "true"; // Check for view mode flag in localStorage
      this.setState({ isViewMode });
      this.loadLocalStorageData();
      const questionId = localStorage.getItem("selectedQuestionId");
      const options = {
        url: API_URL.BACKEND_SERVICE_API_URL + `/question/get-Question-details/${questionId}`,
        method: "GET",
        headers: {
          authorization: localStorage.getItem('token')
        }
      };
      let response = await request(options);
      this.setState({ selectedQuestionData: response.payload }, this.updateSelectedCategories);
    } catch (err) {
      console.log(err);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.isViewMode !== this.state.isViewMode && this.reactQuillRef) {
      const editor = this.reactQuillRef.getEditor();
      if (this.state.isViewMode) {
        editor.disable();
      } else {
        editor.enable();
      }
    }
  }
  loadLocalStorageData = async () => {
    //Store category
    let category = localStorage.getItem('category');
    if (category) {
      category = JSON.parse(category);
      this.setState({ category });
    } else {
      let response = await this.props.listCategory();
      if (response.payload.length !== 0) {
        const searchString = JSON.stringify(response.payload);
        localStorage.setItem('category', searchString);
        category = JSON.parse(searchString);
        this.setState({ category });
      }
    }
    // Store Language
    let language = localStorage.getItem('language');
    if (language) {
      language = JSON.parse(language);
      this.setState({ language });
    } else {
      let response = await this.props.listLanguage();
      if (response.payload.length !== 0) {
        const languages = JSON.stringify(response.payload);
        localStorage.setItem('language', languages);
        language = JSON.parse(languages);
        this.setState({ language });
      }
    }
  }

  handleInput = async (e) => {
    try {
      const { selectedQuestionData } = this.state;
      if (e.target === undefined) {
        const question_description = e;
        this.setState({
          selectedQuestionData: {
            ...selectedQuestionData,
            question_description
          }
        });
      }
      else {
        let tid = e.target.id;
        switch (tid) {
          case 'question':
            const question = e.target.value;
            this.setState({
              selectedQuestionData: {
                ...selectedQuestionData,
                question
              }
            });
            break;
          case 'question_status':
            const question_status = e.target.value;
            this.setState({
              selectedQuestionData: {
                ...selectedQuestionData,
                question_status
              }
            });
            break;
          case 'category_id':
            const category_id = e.target.value;
            this.setState({
              selectedQuestionData: {
                ...selectedQuestionData,
                category_id
              }
            });
            break;
          case 'question_language':
            const question_language = e.target.value;
            this.setState({
              selectedQuestionData: {
                ...selectedQuestionData,
                question_language
              }
            });
            break;
          case 'question_notes':
            const question_notes = e.target.value;
            this.setState({
              selectedQuestionData: {
                ...selectedQuestionData,
                question_notes
              }
            });
            break;
          default:
            console.log("No Matching target found in handleInput");
            break;
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  updateSelectedCategories = () => {
    const { selectedQuestionData, category } = this.state;
    // Map category names from selectedQuestionData to categoryOptions
    if (selectedQuestionData?.category) {
      const selectedCategoriesData = selectedQuestionData.category.map((categoryName) => {
        // Find the option matching each category name
        return category.find(cat => cat.category_name === categoryName) 
          ? { value: category.find(cat => cat.category_name === categoryName).id, label: categoryName }
          : null;
      }).filter(cat => cat !== null); // Remove null values if category not found
      this.setState({ selectedCategories: selectedCategoriesData });
    }
  };
  
  handleCategoryChange = (selectedCategories) => {
    // Update the state with the selected categories **(New Addition)**
    this.setState({ selectedCategories });
  }
  
  onUpdate = async (e) => {
    if (this.state.isViewMode) return; 
    e.preventDefault()
    try {
      const { selectedQuestionData,selectedCategories  } = this.state;
      let isStatus;
      if (selectedQuestionData.question_status === 'Active') {
        isStatus = 1;
      } else if (selectedQuestionData.question_status === 'Inactive') {
        isStatus = 0;
      }
      const categoryIds = selectedCategories.map((category) => category.value);
      let updateResponse = await this.props.updateQuestion({
        id: selectedQuestionData.id,
        question: selectedQuestionData.question,
        status: isStatus,
        categoryIds: categoryIds,
        question_language: selectedQuestionData.question_language,
        question_description: selectedQuestionData.question_description,
        question_notes: selectedQuestionData.question_notes
      });
      toast.success(updateResponse.message, { autoClose: 10000 });
      if (localStorage.getItem("selectedCategoryId")) {
        window.open("/question-category/category-details/", "_self");
      }
      else {
        window.open("/question-category/question/", "_self");
      }
    } catch (err) {
      toast.error(err.response.data.message, { autoClose: 10000 });
      console.log(err);
    }
  }

    // Function to toggle mode (view/edit)
    toggleMode = (isViewMode) => {
      localStorage.setItem("isViewMode", isViewMode); // Save mode to localStorage
      this.setState({ isViewMode }); // Update local state
    };

  render() {
    const { category, language, selectedQuestionData, selectedCategories, isViewMode   } = this.state;
    // Prepare options for the multi-select dropdown **(New Addition)**
    const categoryOptions = category.map((cat) => ({
      value: cat.id,
      label: cat.category_name
    }));

    return (
      <Fragment>
        <ToastContainer />
        <div className='page-title'>
          <Row>
            <Col xs='12'>
              <ol className='breadcrumb'>
                <li className='breadcrumb-item'>
                  <Link to="/dashboard/">
                    <SvgIcon iconId='stroke-home' />
                  </Link>
                </li>
                <li className='breadcrumb-item'>
                  <Link style={{ "color": "#000" }} to="/question-category/question/">Question Category</Link>
                </li>
                <li className='breadcrumb-item active'>Question Details</li>
              </ol>
            </Col>
          </Row>
        </div>
        <Container fluid={true}>
          <div className='edit-profile'>
            <Row>
              <Col sm="12">
                <Card>
                  <CardHeader className='d-flex align-items-center justify-content-between'>
                    <H5> Question Details</H5>
                  </CardHeader>
                  <Form onSubmit={this.onUpdate}>
                    <CardBody>
                      <Row>
                        <Col md="12">
                          <FormGroup className="mb-3 mt-3">
                            <Label className="form-label">Question</Label>
                            <Input type="text" name="question" id="question" placeholder="Enter Question" value={selectedQuestionData.question || ''} onChange={this.handleInput} disabled={isViewMode}/>
                          </FormGroup>
                        </Col>
                        <Col md="4">
                           {/* Multi-Select Dropdown for Categories **(New Addition)** */}
                           <FormGroup>
                            <Label className="form-label">Select Categories</Label>
                            <Select
                              options={categoryOptions}
                              isMulti
                              value={selectedCategories}
                              onChange={this.handleCategoryChange}
                              isDisabled={isViewMode}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label className="form-label">Question Language</Label>
                            <Input type="select" name="question_language" id="question_language" value={selectedQuestionData.question_language || ''} onChange={this.handleInput} disabled={isViewMode}>
                              <option value=''>Select Language</option>
                              {language.map((data, i) =>
                                <option key={i} value={data.language_name}>{data.language_name}</option>
                              )}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label className="form-label">Question Description</Label>
                            <ReactQuill
                            ref={(el) => { this.reactQuillRef = el }}
                              id="question_description"
                              name="question_description"
                              value={selectedQuestionData.question_description || ''}
                              onChange={this.handleInput}
                              readOnly={this.state.isViewMode}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label className="form-label">Question Notes(Internal)</Label>
                            <Input type="textarea" placeholder="Enter Question Notes" id="question_notes" name="question_notes" value={selectedQuestionData.question_notes || ''} onChange={this.handleInput} disabled={isViewMode}/>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                    {!isViewMode && (
                    <CardFooter className="text-center">
                      <Btn attrBtn={{ color: "primary", type: "submit" }} >{Update}</Btn>&nbsp;&nbsp;&nbsp;
                      <Link to="/question-category/question/">
                        <Btn attrBtn={{ color: "primary", type: "reset" }} >{Cancel}</Btn>
                      </Link>
                    </CardFooter>
                    )}
                  </Form>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </Fragment >
    )
  }
}
const mapStateToProps = () => { return {} };

const mapDispatchToProps = {
  updateQuestion: questionOperations.updateQuestion,
  listCategory: categoryOperations.listCategory,
  listLanguage: masterOperations.listLanguage
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionEdit)